var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLetter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 6H2.92a.78.78 0 00-.21 0l-.17.07a.65.65 0 00-.15.1.67.67 0 00-.15.14l-.06.06a.36.36 0 000 .09 1.08 1.08 0 00-.08.19 1.29 1.29 0 00-.1.25V25a1 1 0 001 1h26a1 1 0 001-1V7a1 1 0 00-1-1zm-13 8.81L6.2 8h20.89zM4 24V8.91l11.43 7.91a1.51 1.51 0 00.18.09h.08A1.09 1.09 0 0016 17a1 1 0 00.41-.1h.07L28 9.79V24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter);
export default __webpack_public_path__ + "static/media/letter.6c62741cca831b88a43e07425d2d8b8d.svg";
export { ForwardRef as ReactComponent };